import { useParams } from "react-router";
import { useRootStore } from "store";
import { useIsMobile } from "hooks/use-is-mobile";

import ThreadPreviewDesktop from "views/inbox/components/Inbox/main/threadPreview/desktop";
import ThreadPreviewMobile from "views/inbox/components/Inbox/main/threadPreview/mobile";
import MessagePreview from "./main/messagePreview";
import { Loader } from "components/loader/Loader";

export default function InboxPreview() {
  const isMobile = useIsMobile();
  const { inboxType } = useParams<{
    inboxType?: string;
  }>();

  const { isLoadingMyThreads, isLoadingAllThreads, isLoadingSentMessages } =
    useRootStore((state) => state.inbox);

  const isLoadingInbox =
    isLoadingMyThreads ||
    isLoadingAllThreads ||
    isLoadingSentMessages;

  const renderContent = () => {
    if (isLoadingInbox) {
      return (
        <div className="w-100 d-flex justify-content-center">
          <Loader className="mr-3" /> Laddar konversationen...
        </div>
      );
    }
    switch (inboxType) {
      case "sent":
        return <MessagePreview />;
      case "my":
      case "all":
      case "new":
        return (
          <>{isMobile ? <ThreadPreviewMobile /> : <ThreadPreviewDesktop />}</>
        );
    }
  };

  return (
    <div
      className={`inbox-content-wrapper d-flex w-100}`}
    >
      {renderContent()}
    </div>
  );
}
